// extracted by mini-css-extract-plugin
module.exports = {"assets-section":"HowItWorksAssets_assets-section__1_Vxr"};